import axios from 'axios';
import store from '../store';
import DEFINES from '@/defines';
import router from '@/router';

const HASH_ALGO = 'sha256';
const BASE_API_URL = DEFINES.BASE_API_URL;
const BUILD_MODE = process.env.VUE_APP_BUILD_MODE;
const BUILD_VERSION = process.env.VUE_APP_BUILD_VERSION;

async function callApi(url, payload) {
    store.dispatch('app/showLoader');
    return axios
        .post(BASE_API_URL + url, payload, buildHeaders())
        .then(response => {
            return parseResponse(response);
        })
        .catch((error) => {
            //catch axios errors
            if (error.response != undefined) {
                return parseHttpError(error.response);
            } else {
                //its rms server error data
                throw error;
            }
        })
        .finally(function () {
            store.dispatch('app/hideLoader');
        });
}

async function callGetReqApi(url, payload, ) {
    store.dispatch('app/showLoader');
    return axios
        .get(BASE_API_URL + url, payload)
        .then(response => {
            return parseResponse(response);
        }).catch((error) => {
            //catch axios errors
            if (error.response != undefined) {
                return parseHttpError(error.response);
            } else {
                //its rms server error data
                throw error;
            }
        })
        .finally(function () {
            store.dispatch('app/hideLoader');
        });
}

async function handleError (error) {
  if (error) {
    //FIXME:: handle error properly
    // var is_avail_session = store.getters['app/isAvailsSession'];
    // if (is_avail_session) {
    //     store.commit("availLink/setErrorMessage", {
    //         message: error.message,
    //     });
    //     router.push({
    //         path: '/errorWithAvailLink'
    //     });
    // }
        if (error.code == 1019) {
            store.dispatch('resetAll');
            router.push({
                path: '/login'
            });
        }
        store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
        });

    }
};

const buildHeaders = () => {
    return {
        headers: {
            Authorization: 'Bearer ' +
                JSON.stringify(getAuthHash()),
        },
    };
};

const getAuthHash = () => {
    let nonce = require('nonce')();
    //FIXME: Implement Server Side Security
    let timestamp = '1' + nonce();
    let key = store.state.auth.key;
    let secret = store.state.auth.secret;

    let signature = key + secret + timestamp;

    let hash = null;

    if (key && secret) {
        hash = doHash(signature);
    }

    return {
        key: store.state.auth.key,
        timestamp: timestamp,
        hash: hash,
        version: BUILD_VERSION,
        build_mode: BUILD_MODE,
    };
};

const doHash = req => {
    let shajs = require('sha.js');
    let hash = shajs(HASH_ALGO).update(req).digest('hex');
    return hash;
};

const parseHttpError = response => {
    //server is down
    //console.log (response);
    let error = response.status + ' : ' + response.statusText;
    //FIXME: have to handle http error here status field is not received from api response
};

const parseResponse = response => {

    handleError(response.data.error)
    //2.  Non-handleable errors
    if (response.data.error) {
        throw response.data.error;
    }

    //3. Data is OK
    if (response.status == 200) {
        return response.data.data;
    }

    //4. Unknown Stage
    throw {
        title: 'Unknown API response'
    };
};

export {
    callApi,
    callGetReqApi,
    parseHttpError,
    buildHeaders
};
